var f = Object.defineProperty, i = Object.defineProperties;
var n = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var m = (e, o, r) => o in e ? f(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, p = (e, o) => {
  for (var r in o || (o = {}))
    c.call(o, r) && m(e, r, o[r]);
  if (t)
    for (var r of t(o))
      d.call(o, r) && m(e, r, o[r]);
  return e;
}, a = (e, o) => i(e, n(o));
import s, { forwardRef as g } from "react";
import l from "../lib/IconBase.mjs";
import w from "../defs/CodepenLogo.mjs";
const C = g((e, o) => /* @__PURE__ */ s.createElement(l, a(p({ ref: o }, e), { weights: w })));
C.displayName = "CodepenLogo";
export {
  C as CodepenLogo
};
